import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { EJType, useTypesTableContext } from '../../../TypesTableContext'
import { CIMSTag } from '../../../../../../../../../../components/CIMSTag'
import { alphabeticalSort, EJReportType } from 'shared'
import UserTags from '../../../../../../../../../../components/CIMSTags/common/UserTags'

export const useColumns = (): CIMSColumn<EJType>[] => {
  const { records } = useTypesTableContext()

  return [
    useNameColumn({
      help: HelpMessage.Name,
      width: 300,
      sort: { default: 'ascend' },
    }),
    {
      title: 'Allowance Description',
      render: ({ allowanceDescription }) => allowanceDescription,
      width: 400,
      filter: { type: 'search', with: 'key', key: 'allowanceDescription' },
      sort: { with: 'key', key: 'allowanceDescription' },
      help: HelpMessage.EngineeringJudgements.Types.AllowanceDescription,
    },
    {
      title: 'Report Type',
      width: 150,
      help: HelpMessage.EngineeringJudgements.Types.ReportType,
      render: ({ reportTypeId }) => {
        const ejReportType = EJReportType.fromId(reportTypeId)
        if (ejReportType) {
          return (
            <CIMSTag style={{ verticalAlign: 'top' }}>
              {ejReportType.type}
            </CIMSTag>
          )
        }

        return null
      },
      filter: {
        type: 'default',
        with: 'items',
        items: EJReportType.filter(({ id }) => id !== EJReportType.Gradation.id)
          .sort(alphabeticalSort('type'))
          .map(({ id, type }) => ({
            text: type,
            value: id,
          })),
        key: 'reportTypeId',
      },
    },
    {
      title: 'Issuers',
      width: 300,
      help: HelpMessage.EngineeringJudgements.Types.Issuers,
      render: ({ users }) => <UserTags users={users} />,
      filter: {
        with: 'callback',
        items: records
          ?.flatMap(({ users }) => users)
          .map(({ id, displayName, mail }) => ({
            text: displayName ?? mail,
            value: id,
          }))
          .sort(alphabeticalSort('text')),
        onFilter: (value, { users }) => users.some(({ id }) => id === value),
      },
    },
  ]
}
